import { Component, OnInit } from '@angular/core';
import {AuthService} from '../auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loading = false;
  public working = false;

  constructor(private authService: AuthService) {

  }

  ngOnInit(): void {
  }

  login() {
    this.working = true;

    this.authService.login('dashboard');
  }
}
